import React, { useState } from 'react';
import styles from './CauseInfoView.module.scss';
import { useTranslation } from 'react-i18next';
import love from './love.svg';
import { Box } from '@material-ui/core';
import VLButton from '../../../Reusables/Buttons/VLButton';

const CauseInfoView = (props) => {
  const { t, i18n } = useTranslation();

  let cause = props.User && props.User.cause ? props.User.cause : {};

  let info = cause && cause.info ? cause.info : '';
  let infoUrl = cause && cause.infoURL ? cause.infoURL : '';
  let title = cause && cause.name ? cause.name : '';
  let subTitle = t('my_cause');

  return (
    <div
      className={`${styles.model} ${i18n.language === 'he' ? styles.heb : ''}`}
    >
      <img src={love} className={styles.img} alt="heart" />
      <div className={styles.title}>{title}</div>
      <Box mt={1}>
        <div className={styles.subTitle}>{subTitle}</div>
      </Box>
      <Box p={2}>
        <div className={styles.text}>{info}</div>
      </Box>
      <a href={infoUrl} target="_blank" rel="noreferrer">
        <div className="mt-5">
          <div className={styles.button}>
            {t('cause_info_view_visit_website')}
          </div>
        </div>
      </a>
      <Box mt={1}>
        <VLButton
          style={{ width: '200px', color: '#AE9BDE' }}
          variant="text"
          color="primary"
          onClick={() => props.closeClicked()}
        >
          {t('close')}
        </VLButton>
      </Box>
    </div>
  );
};

export default CauseInfoView;
